import React from 'react';
import { Box, Container, Divider, Link as MuiLink, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import BrandLogo from '@src/components/BrandLogo';
import { APP_VERSION } from '@src/version';

const LINKS = [
    { label: 'Términos y Condiciones', to: '/terms' },
    { label: 'Aviso de Privacidad', to: '/privacy' },
    { label: 'Eliminar mis datos', to: '/data-deletion' }
];

const Footer: React.FC = () => (
    <Box component="footer" sx={{ mt: 'auto', bgcolor: 'background.paper', borderTop: 1, borderColor: 'divider' }}>
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Stack spacing={2.5} alignItems="center">
                <BrandLogo size={28} />

                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={{ xs: 1, sm: 3 }}
                    alignItems="center"
                    divider={<Divider orientation="vertical" flexItem sx={{ display: { xs: 'none', sm: 'block' } }} />}
                >
                    {LINKS.map((link) => (
                        <MuiLink
                            key={link.to}
                            component={Link}
                            to={link.to}
                            underline="hover"
                            color="text.secondary"
                            variant="body2"
                        >
                            {link.label}
                        </MuiLink>
                    ))}
                </Stack>

                <Typography variant="caption" color="text.secondary" textAlign="center">
                    © {new Date().getFullYear()} Kabandú Orígenes S.A. de C.V. · v{APP_VERSION}
                </Typography>
            </Stack>
        </Container>
    </Box>
);

export default Footer;
